import { idNameItem } from "jk-service";


export const buysaleList: idNameItem[] = [
  { id: '0', name: '買' },
  { id: '1', name: '賣' },
];

  // 1:未成交  5:已刪除 8:部分成交  9:全部成交
export const orderStateList: idNameItem[] = [
    { id: '1', name: '未成交' },
    { id: '5', name: '已刪除' },
    { id: '8', name: '部分成交' },
    { id: '9', name: '全部成交' },
  ];
// 當沖
export const dayTradeList: idNameItem[] = [
  { id: '0', name: '一般' },
  { id: '1', name: '當沖' },
];
// 新平倉  0:新倉 1:平倉 2:自動  {新期貨、選擇權使用}
export const newCloseList: idNameItem[] = [
  { id: '0', name: '新倉' },
  { id: '1', name: '平倉' },
  { id: '2', name: '自動' },
];

// U006	  委託條件 sTradeType;	0:ROD  1:IOC  2:FOK
export const tradeTypeList: idNameItem[] = [
  { id: '0', name: 'ROD' },
  { id: '1', name: 'IOC' },
  { id: '2', name: 'FOK' },
];
// 價格 0:限價 1:市價 2:範圍市價
export const priceTypeList: idNameItem[] = [
  { id: '0', name: '限價' },
  { id: '1', name: '市價' },
  { id: '2', name: '範圍市價' },
];

/**
 * capital股票即時資訊
 */
export class SKSTOCKLONG {
  nStockidx: number = 0; // 商品自定索引代號
  sDecimal: number = 0; // 小數位數
  sTypeNo: number = 0; //  EX: (證券)類股別 1 水泥 , 2 食品…etc.
  bstrMarketNo: string = ""; // 市埸代碼
  bstrStockNo: string = ""; // 商品代碼EX: 1101 台泥, TX12 台指期12月…etc.
  bstrStockName: string = ""; // 商品名稱
  nHigh: number = 0; // 最高價
  nOpen: number = 0; // 開盤價
  nLow: number = 0; // 最低價
  nClose: number = 0; // 成交價
  nTickQty: number = 0; // 單量
  nRef: number = 0; // 昨收、參考價
  nBid: number = 0; // 買價
  nBc: number = 0; // 買量
  nAsk: number = 0; // 賣價
  nAc: number = 0; // 賣量
  nTBc: number = 0; // 買盤量(即外盤量)
  nTAc: number = 0; // 賣盤量(即內盤量)
  nFutureOI: number = 0; // 期貨未平倉 OI
  nTQty: number = 0; // 總量
  nYQty: number = 0; // 昨量
  nUp: number = 0; // 漲停價
  nDown: number = 0; // 跌停價
  nSimulate: number = 0; // 揭示 0:一般 1:試算　＊ // [證券逐筆]盤中出現『1:試算』代表行情劇動，觸發價格穩定措施狀態
  nDayTrade: number = 0; // [限證券整股商品]可否當沖 0:一般 1:可先買後賣現股當沖 2:可先買後賣和先賣後買現股當沖
  nTradingDay: number = 0; // 交易日(YYYYMMDD)  備註 :當日非交易日時, 資料為前一交易日
}

/**
 * @class StockQuote
 * capital股票即時資訊+股票期貨 追蹤資訊
 * SKSTOCKLONG + STKTM
 */
export class StockQuoteCapital extends SKSTOCKLONG {
  TM001!: ""; // 單號
  TM002!: ""; // 商品代號
  TM003!: ""; // 名稱
  TM004!: "N"; // 結案碼
  TM005!: Date; // 更新時間
  TM006!: ""; // 狀態
  TM007!: ""; // 日期
  TM008!: 0; // 庫存數量
  TM009!: 0; // 最大數量
  TM010!: 0; // 平均成本
  TM011!: ""; // 觀盤重點
  TM100!: 0; // 開盤價
  TM101!: Date; // 開盤時間
  TM102!: 0; // 最高價
  TM103!: Date; // 最高價時間
  TM104!: 0; // 最低價
  TM105!: Date; // 最低價時間
  TM106!: 0; // 總成交量
  TM107!: Date; // 最新一筆成交時間
  TM108!: 0; // 最新一筆成交價格
  TM109!: 0; // 最新一筆成交張數
  TM110!: 0; // 突破通知價
  TM111!: 0; // 跌破通知價
  TM112!: 0; // 停損價
  TM113!: 0; // 第一停利價
  TM114!: 0; // 第二停利價
  TM115!: 0; // 支撐1
  TM116!: 0; // 支撐2
  TM117!: 0; // 壓力
}

//[以下capital 訂單/智慧單]==============================================

/**
 * capital 報價前端的參數結構
 */
export class capitalQuoteOption {
  action: string = ""; // "RequestKLineAMByDate",
  message: string = "";
  stockNo?: string = ""; // "MTX00",
  KLineType?: number = 0; // 0:分鐘線 4:日線 5:周線 6:月線
  TradeSession?: number = 0; // 0 = 全盤技術分析 1 = AM盤技術分析
  MinuteNumber?: number = 1; // 指定幾分K (ex : 1=1分K, 3=3分K)
  date1?: string; // "20221014",
  date2?: string; //"20221015"
  sMarketNo?: number = 0;
  connectId = 1;
  time4A?: string;
  time4B?: string;
  n1?: number;
  n2?: number;
  n3?: number;
  s1?: string;
  s2?: string;
  s3?: string;
}

/**
 * capital 訂單前端的參數結構
 */
export class capitalOrderOption {
  uid: string = "";
  message: string = "";
  action: string = "";
  bAsyncOrder: boolean = false;
  bstrFullAccount: string = "";
  bstrStockNo: string = "";
  sPrime: number = 0; //0:上市上櫃1:興櫃
  sPeriod: number = 0; //0:盤中 1:盤後 2:零股
  sFlag: number = 0; //0:現股 1:融資 2:融券 3:無券
  sBuySell: number = 0; //0:買進 1:賣出
  bstrPrice: string = ""; //委託價格，「M」表示參考價（昨收價）
  nQty: number = 0; //整股交易為張數，如果是零股則為股數
  nTradeType: number = 0; //[證券逐筆交易]0:ROD ; 1:IOC ; 2:FOK
  nSpecialTradeType: number = 1; //[證券逐筆交易]1:市價; 2:限價
  sDayTrade: number = 0; //  = (short) nFlag;
  sTradeType: number = 0; // = (short) nPeriod;
}

/**
 * 期貨下單
 */
export class FutureOrderItem {
  bstrFullAccount: string = ""; //期貨帳號，分公司代碼＋帳號7碼
  bstrStockNo: string = ""; //委託期權代號
  sTradeType: number = 0; //0:ROD  1:IOC  2:FOK
  sBuySell: number = 0; //0:買進 1:賣出
  sDayTrade: number = 0; //當沖0:否 1:是，可當沖商品請參考交易所規定。
  sNewClose: number = 0; //新平倉，0:新倉 1:平倉 2:自動{新期貨、選擇權使用}
  bstrPrice: string = ""; //委託價格，「M」表示市價，「P」表示範圍市價
  nQty: number = 0; //交易口數
  sReserved: number = 0; //{期貨委託SendFutureOrderCLR適用}盤別，0:盤中(T盤及T+1盤)；1:T盤預約
}

/** 5-2-1 期、選智慧單▼ */
export class FutureOrderSmartItem {
  bstrFullAccount: string = ""; //期貨帳號，分公司代碼＋帳號7碼
  bstrStockNo: string = ""; //委託期權商品代號
  sTradeType: number = 0; //0:ROD 3:IOC 4:FOK
  sBuySell: number = 0; //0:買進 1:賣出
  sDayTrade: number = 0; //當沖0:否 1:是，可當沖商品請參考交易所規定。
  sNewClose: number = 0; //新平倉，0:新倉 1:平倉 2:自動
  bstrPrice: string = ""; //委託價格，(指定限價時，需填此欄)、[OCO]停利委託價。  //請設nOrderPriceType代表範圍市價，不可用特殊價代碼「P」代表範圍市價 //{移動停損不須填委託價格}
  bstrPrice2: string = ""; //[OCO]停損委託價。
  nQty: number = 0; //交易口數
  bstrTrigger: string = ""; //觸發價，觸發基準價、[OCO]停利觸發價。 //{期貨停損、移動停損、選擇權停損、MIT、OCO下單使用：不可0、不可給特殊價代碼P}
  bstrTrigger2: string = ""; //[OCO]停損觸發價。
  bstrMovingPoint: string = ""; //{僅移動停損下單使用}移動點數。
  sReserved: number = 0; //盤別，0:盤中(T盤及T+1盤)；1:T盤預約{MIT 單不須填盤別}
  bstrDealPrice: string = ""; //成交價 {限MIT下單使用：不可0、不可給特殊價代碼, 需自行取得委託當下成交價}
  bstrSettlementMonth: string = ""; // 委託商品年月，YYYYMM共6碼(EX: 202206) 若委託期貨商品代號為TX00、 MTX00等近月商品，則可忽略bstrSettlementMonth商品年月
  nOrderPriceType: number = 0; // 委託價類別  2: 限價; 3:範圍市價 （不支援市價）//sTradeType為ROD時，nOrderPriceType僅可指定限價
  nTriggerDirection: number = 0; //{限MIT下單使用} 觸發方向1:GTE, 2:LTE
}
/**
 * // 5-2-2 期、選MIT▼ 訂單
 * */
export class FutureOrderMITItem {
  bstrFullAccount: string = ""; //期貨帳號，分公司代碼＋帳號7碼
  bstrStockNo: string = ""; //委託期權代號
  sTradeType: number = 0; //0:ROD  3:IOC  4:FOK
  sBuySell: number = 0; //0:買進 1:賣出
  sDayTrade: number = 0; //當沖0:否 1:是，可當沖商品請參考交易所規定。
  sNewClose: number = 0; //新平倉，0:新倉 1:平倉 2:自動

  nQty: number = 0; //交易口數
  bstrTrigger: string = ""; //觸發價。//{ MIT下單使用：不可0、不可給特殊價代碼}
  bstrDealPrice: string = ""; //成交價 {限MIT下單使用：不可0、不可給特殊價代碼}
  bstrPrice: string = ""; //委託價格  (指定限價時，需填此欄)
  bstrSettlementMonth: string = ""; // 委託商品年月，YYYYMM共6碼(EX: 202206)
  //若 bstrStockNo指定月份，需填商品契約年月
  nOrderPriceType: number = 0; // 2: 限價; 3:範圍市價
  nTriggerDirection: number = 0; //觸發方向1:GTE, 2:LTE
}

// 證券下單
export class StockOrderItem {
  bstrFullAccount: string = ""; //證券帳號，分公司代碼＋帳號7碼
  bstrStockNo: string = ""; //委託股票代號
  sPrime: number = 0; //0:上市上櫃1:興櫃
  sPeriod: number = 0; //0:盤中 1:盤後 2:零股
  sFlag: number = 0; //0:現股 1:融資 2:融券 3:無券
  sBuySell: number = 0; //0:買進 1:賣出
  bstrPrice: string = ""; //委託價格，「M」表示參考價（昨收價）
  nQty: number = 0; //整股交易為張數，如果是零股則為股數
  nTradeType: number = 0; //[證券逐筆交易]0:ROD ; 1:IOC ; 2:FOK
  nSpecialTradeType: number = 0; //[證券逐筆交易]1:市價; 2:限價 (市價單之委託價格Price請給0; 限價單之委託價格Price 不可為0)
}

// 證券智慧單MIT
export class StockStrategyOrderMit {
  // 證券智慧單MIT
  bstrFullAccount: string = ""; //證券帳號，分公司四碼＋帳號7碼
  bstrStockNo: string = ""; //委託股票代號
  bstrOrderPrice: string = ""; //委託價  (若為市價單, 委託價請填0)
  bstrTriggerPrice: string = ""; //觸發價
  bstrDealPrice: string = ""; //成交價  (當下市價)，洗價機留存用
  nOrderType: number = 0; //委託 0:現;3(自)融資;4: (自)融券;8:無券賣出
  nBuySell: number = 0; //0買;1賣出
  nQty: number = 0; //張數
  nOrderPriceType: number = 0; //1:市價;2:限價
  nOrderCond: number = 0; //0:ROD;3:IOC;4:FOK
  nTriggerDir: number = 0; //觸價方向1: >=大於等於 ;2:<=小於等於
}

//	已實現損益查詢
export class TSProfitLossGWQuery {
  bstrFullAccount: string = "";
  nTPQueryType: number = 0; //損益類別 1: 已實現損益
  nFunc: number = 0; //損益回傳格式
  bstrStockNo: string = ""; //當nFunc 為 1:明細 及3: 彙總依股票代號 時，指定商品代碼
  bstrTradeType: string = ""; //當nFunc 為 1:明細，指定交易類別
  //0:現股 1:融資(代) 2:融券(代) 3:融資(自) 4:融券(自)

  bstrStartDate: string = "";
  //當nFunc 為 0:彙總 時，起始日西元年月日//YYYYMMDD
  //當nFunc 為 1:明細 及 3:彙總依股票代號 時，起始日民國年月日
  bstrEndDate: string = ""; //當nFunc 為 0:彙總 時，結束日西元年月日//YYYYMMDD
  //當nFunc 為 1:明細格式時,不需填結束日
  //當nFunc 3:彙總依股票代號 時，結束日 民國年月日

  bstrBookNo: string = ""; //當nFunc 為 1:明細 時,指定委託書號
  bstrSeqNo: string = ""; //當nFunc 為 1:明細 時,指定序號
}
//智慧單刪單
export class CancelStragyOrder {
  // 智慧單刪單
  bstrFullAccount: string = ""; //證券帳號，分公司四碼＋帳號7碼
  nMarket: number = 0; // 市場別1:國內證券
  bstrParentSmartKey: string = ""; // 智慧母單號;
  bstrSmartKey: string = ""; // 智慧單號; 出場單則給出場單號
  nTradeKind: number = 0; //11:當沖;
  nDeletType: number = 0; //刪單類型 1: 全部; 2: 進場單 ; 3:出場單
  bstrSeqNo: string = ""; //委託序號(1~3三種類型均需提供, 預約單可忽略)

  bstrOrderNo: string = ""; //((刪進場/出場單提供))委託書號，
  //（若觸發，需給書號）
  bstrSmartKeyOut: string = ""; //出場單號(刪全部時提供，刪進場單及出場單時不需提供出場單號) //委託量大於1時，會不止一筆出場單，出場單號以逗號「, 」區隔
  //＊若被動查詢回報結果，當無書號時，則不需提供；若無尚無出場單號，則可不填。
  //＊刪全部及刪進場單時，智慧單母單號與智慧單號相同。
}

//期貨智慧單刪單STP、MST、MIT、OCO:
export class CancelStrategyOrder {
  bstrLogInID: string = ""; //登入ID
  bstrFullAccount: string = ""; //期貨帳號
  nMarket: number = 0; // 市場別2:國內期貨選擇權
  bstrSmartKey: string = ""; // 智慧單號
  nTradeKind: number = 0; //3:OCO、5:STP、8:MIT、9:MST
  bstrSeqNo: string = ""; //委託序號 (預約單可忽略)
  bstrOrderNo: string = ""; //委託書號 （若觸發，需給書號；預約單可忽略）
}

//[capital 技術資料格式]======================================
// capital MACD 格式
export class capitalMACD {
  bstrStockNo: string = ""; // 商品代碼
  bstrMACD: string = ""; // 技術指標MACD平滑異同平均線
  bstrDIF: string = ""; // 技術指標DIF
  bstrOSC: string = ""; // 技術指標OSC
}
// capital 布林通道 格式
export class BoolTunel {
  // 布林通道
  bstrStockNo: string = ""; // 商品代碼
  bstrAVG: string = ""; // 技術指標布林通道 AVG均線
  bstrUBT: string = ""; // 技術指標 UBT通道上端
  bstrLBT: string = ""; // 技術指標 LBT通道下端
}
